module.exports = __webpack_public_path__ + "images/emoji/black_small_square.d2a2ebbe6c3fb519faa6.png";